// extracted by mini-css-extract-plugin
export default {"register_wrap":"RegisterLayout_register_wrap__xYUlo","btn_start":"RegisterLayout_btn_start__qZUEO","animate-rotate":"RegisterLayout_animate-rotate__NWcBB"};